import { ClipSource } from '@air/api/types';

export const SOURCE_MAP: {
  [key in ClipSource]: string;
} = {
  [ClipSource.iOSPhotosLibrary]: 'iOS',
  [ClipSource.app]: 'App',
  [ClipSource.agent]: 'Agent',
  [ClipSource.web]: 'Web',
  [ClipSource.desktop]: 'Air Flow',
  [ClipSource.desktopSync]: 'Air Flow',
  [ClipSource.dropbox]: 'Dropbox',
  [ClipSource.transferred]: 'Transferred',
  [ClipSource.instagram]: 'Instagram',
  [ClipSource.googleDrive]: 'Google Drive',
  [ClipSource.vimeo]: 'Vimeo',
  [ClipSource.smugmug]: 'SmugMug',
  [ClipSource.box]: 'Box',
  [ClipSource.frameio]: 'Frame.io',
  [ClipSource.flickr]: 'Flickr',
  [ClipSource.piction]: 'Piction',
  [ClipSource.sharepoint]: 'SharePoint',
  [ClipSource.sharePoint]: 'SharePoint',
  [ClipSource.quickconnect]: 'QuickConnect',
  [ClipSource.s3]: 'Amazon S3',
  [ClipSource.lightroom]: 'Lightroom',
  [ClipSource.egnyte]: 'Egnyte',
  [ClipSource.brandfolder]: 'Brandfolder',
  [ClipSource.widen]: 'Widen',
  [ClipSource.bynder]: 'Bynder',
  [ClipSource.jsonMetadata]: 'JSON Metadata',
  [ClipSource.publicApi]: 'Public API',
  [ClipSource.canto]: 'Canto',
  [ClipSource.openAsset]: 'OpenAsset',
  [ClipSource.photoshelter]: 'PhotoShelter',
  [ClipSource.webdam]: 'WebDAM',
  [ClipSource.csv]: 'CSV',
  [ClipSource.starchive]: 'Starchive',
  [ClipSource.sftp]: 'SFTP',
  [ClipSource.figma]: 'Figma',
  [ClipSource.mediaValet]: 'MediaValet',
  [ClipSource.orangeLogic]: 'Orange Logic',
  [ClipSource.meta]: 'Meta Ad',
  [ClipSource.canvas]: 'Canvas',
  [ClipSource.premierePro]: 'Premiere Pro',
  [ClipSource.chromeExtension]: 'Chrome Extension',
  [ClipSource.iconik]: 'Iconik',
  [ClipSource.lingo]: 'Lingo',
  [ClipSource.aprimo]: 'Aprimo',
};

const SourceKeys = Object.keys(SOURCE_MAP);

// `indexOf` rather than `Array.prototype.includes` because the package's `lib` is `ES2015` and
// `includes` is `ES2016` — using it here trips ts(2550). `indexOf !== -1` is the pre-ES2016
// equivalent and avoids allocating a `Set` for ~40 keys.
export const isKnownClipSource = (source: string): source is ClipSource => SourceKeys.indexOf(source) !== -1;
